import axiosInstance from "utils/axios";

const getSoldCarList = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-sold/getListSoldCar", {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sold car list:", error);
    throw error;
  }
};

const getSoldCarById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-sold/getDetailSoldCarById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching sold car by ID:", error);
    throw error;
  }
};

const SoldeCarService = {
  getSoldCarList,
  getSoldCarById,
};
export default SoldeCarService;
